export const name = "ST_ASBINARY";
export const summary = `Converts a \`GEOGRAPHY\` value to a \`BYTES\` WKB geography value.`;
export const reference = `
## ST_ASBINARY

Converts a \`GEOGRAPHY\` value to a \`BYTES\` WKB geography value.

\`\`\`
ST_ASBINARY(geography_expression)
\`\`\`

### Description

Returns the WKB representation of an input\`GEOGRAPHY\`.

See \`ST_GEOGFROMWKB\` to construct a\`GEOGRAPHY\` from WKB.


### Return type

\`BYTES\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
